import { useUserPreferencesMutation } from './useUserPreferencesMutation'
import { useUserPreferencesQuery } from './useUserPreferencesQuery'

export const useUserPreferences = ({ queryOptions = {}, mutationOptions = {} } = {}) => {
  const { data: preferences, isLoading, isError: isPreferencesQueryError } = useUserPreferencesQuery(queryOptions)
  const { mutate: updateUserPreferences } = useUserPreferencesMutation(mutationOptions)

  return {
    preferences,
    isPreferencesQueryError,
    isLoadingPreferences: isLoading,
    updateUserPreferences
  }
}
